import React, { useState } from "react";
import { Col, Form } from "react-bootstrap";
import { useJsApiLoader, GoogleMap, Marker } from "@react-google-maps/api";

import ScreenHeader from "../../components/ScreenHeader/ScreenHeader";
import Footer from "../../components/Footer/Footer";
import ContactDetails from "../../components/ContactDetails";

import styles from "./styles.module.scss";
import images from "../../../core/constants/images";
import strings from "../../../core/constants/strings";
import MainButton from "../../components/MainButton";
import ScrollUp from "../../components/ScrollUp/ScrollUp";
import { googleMapCenterPos } from "../../../core/constants/data";
import { sendEmailToNMCP } from "../../../functions/firebase";
import FormNmcp from "../../components/HomepageContents/FormNmcp";
import NewPeopleGallery from "../../components/HomepageContents/newPeopleGallery";

const ContactUs = () => {
  const [name, setName] = useState<string>("");
  const [message, setMessage] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [emailError, setEmailError] = useState<boolean>(false);

  //We need to insert google maps api key
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "",
  });

  if (!isLoaded) {
    return <span></span>;
  }

  const validate = () => {
    let emailError = "";

    if (!email.includes("@")) {
      return (emailError = "email invalid");
    }
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const isValid = validate();
    if (isValid !== null) {
      setEmailError(false);
    }
    if (!emailError) {
      setName("");
      setMessage("");
      setEmail("");
    }
  };

  return (
    <div>
      <div className={styles.discordContainer}>
        <span className={styles.getInTouchHeadline}>
          {strings.contactUs.getInTouch}
        </span>
        <span className={styles.discordAndMail}>
          {strings.contactUs.discord}
        </span>
        <img
          src={images.discord}
          className={styles.discord}
          onClick={() => window.open("https://discord.gg/xMV2zwdjfr")}
        />
        <NewPeopleGallery />
      </div>
      <ScrollUp />
      <Footer />
    </div>
  );
};

export default ContactUs;
